
import { ParallaxEffect, ParallaxContext } from '../ParallaxEffect';
import { BaseParallaxEffect } from '../BaseParallaxEffect';

export class TargetingReticlesEffect extends BaseParallaxEffect implements ParallaxEffect {
    public render(pc: ParallaxContext): void {
        const { ctx, layerIndex, config, time, width, height } = pc;
         const count = Math.floor(6 * (config.parallaxComplexity || 1.0));
        const curTime = time * config.parallaxSpeed;
        const scale = config.parallaxScale || 1.0;

        ctx.strokeStyle = pc.color;
        ctx.lineWidth = 1 * scale;

        const drawReticle = (x: number, y: number, s: number) => {
             ctx.save();
             ctx.translate(x, y);
             ctx.rotate(curTime * 0.5);
             
             // Animated brackets
             const b = s * (0.8 + Math.sin(curTime * 2) * 0.1);
             ctx.beginPath();
             ctx.moveTo(-b, -b + 20 * scale); ctx.lineTo(-b, -b); ctx.lineTo(-b + 20 * scale, -b);
             ctx.moveTo(b, -b + 20 * scale); ctx.lineTo(b, -b); ctx.lineTo(b - 20 * scale, -b);
             ctx.moveTo(-b, b - 20 * scale); ctx.lineTo(-b, b); ctx.lineTo(-b + 20 * scale, b);
             ctx.moveTo(b, b - 20 * scale); ctx.lineTo(b, b); ctx.lineTo(b - 20 * scale, b);
             ctx.stroke();

             // ID Text
             ctx.fillStyle = pc.color;
             ctx.font = `${10 * scale}px monospace`;
             ctx.fillText(`LOCK: ${Math.floor(b * 10)}m`, b + 5, 0);
             ctx.restore();
        };

        const draw = () => {
            for (let i = 0; i < count; i++) {
                const rx = (this.pseudoRandom(i) - 0.5) * width * 2;
                const ry = (this.pseudoRandom(i + 10) - 0.5) * height * 2;
                const rs = (100 + this.pseudoRandom(i + 20) * 100) * scale * (1 / (layerIndex + 1));
                
                // Drift
                const dx = Math.sin(curTime * 0.2 + i) * 100;
                const dy = Math.cos(curTime * 0.2 + i) * 100;
                
                drawReticle(rx + dx, ry + dy, rs);
            }
        };

        draw();
        this.applyGlow(pc, draw);
    }
}
